import React from "react";
import { useLocation } from "react-router-dom";
import { Typography, Box } from "@mui/material";
import { COLORS } from "constants/colors";
import AppLayout from "../components/AppLayout";
import StyledButton from "../components/StyledButton";
import { createPayPayQrCode } from "utils/api";
import { useUrlParams } from "hooks/useUrlParams";
import { useTheme } from "@emotion/react";
import ButtonDialog from "../components/ButtonDialog";

function PayPayConfirm() {
  const { soulId } = useUrlParams();
  const location = useLocation();
  const theme = useTheme();

  const queryParams = new URLSearchParams(location.search);
  const productType = queryParams.get("product_type");
  const dataString = queryParams.get("data");

  const [isDisabled, setIsDisabled] = React.useState(false);
  const [openError, setOpenError] = React.useState(false);

  const handleRedirect = async () => {
    setIsDisabled(true);
    try {
      const purchaseData = {
        product_type: productType,
        data: JSON.parse(dataString),
      };
      const { data } = await createPayPayQrCode(soulId, purchaseData);
      window.location.href = data.url;
    } catch (error) {
      console.error("Error creating PayPay QR code:", error);
      setOpenError(true);
      setIsDisabled(false);
    }
  };

  return (
    <AppLayout page="PayPayConfirm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          minHeight: "100vh",
        }}
      >
        <Box
          sx={{
            width: "90%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: COLORS.BACKGROUND_WHITE,
            borderRadius: "5px",
            padding: 4,
            gap: 4,
          }}
        >
          <Box>
            <Typography
              sx={(theme) => ({
                fontSize: "16px",
                whiteSpace: "pre-line",
                fontWeight: "bold",
                textAlign: "center",
                color: "#EB8010", // 落ち着いたオレンジ文字
                backgroundColor: "#FFF9EE", // 薄オレンジ背景
                border: "1px solid #FFD591", // 枠線もやさしめ
                borderRadius: "6px",
                padding: "10px 14px",
                lineHeight: "1.6",
                mt: 1,
              })}
            >
              PayPay決済が完了しても、LINEに戻るまでPayPayアプリを閉じずにそのままお待ちください。
            </Typography>
          </Box>

          <StyledButton
            variant="contained"
            sx={{
              width: "50%",
              fontSize: "17px",
              color: COLORS.TEXT_BLACK,
              border: `2px solid ${COLORS.TEXT_BLACK}`,
            }}
            onClick={handleRedirect}
            disabled={isDisabled}
          >
            購入する
          </StyledButton>
        </Box>
      </Box>
      <ButtonDialog
        open={openError}
        title={"エラー"}
        description={
          "決済処理でエラーが発生しました。運営までお問い合わせください。"
        }
        handleClose={() => setOpenError(false)}
      />
    </AppLayout>
  );
}

export default PayPayConfirm;
